<template>
    <datepicker
        :id="id"
        :name="name"
        :value="date"
        :format="format"
        :fullMonthName="true"
        :required="isRequired"
        :disabled-dates="disabledDates"
        @input="update($event)"
    />
</template>

<script>

    import Datepicker from 'vuejs-datepicker';

    export default {

        components: {
            Datepicker
        },

        props: {
            id: String,
            name: String,
            value: String,
            format: String,
            disableDatesTo: String,
            disableDatesFrom: String,
            isRequired: Boolean,
            shouldEmitEvent: Boolean
        },

        data() {
            return {
                date: '',
                disabledDates: {},
            };
        },

        created() {

            if (this.value) {
                const date = this.value === 'today'
                    ? this.getToday()
                    : this.getDateFromString(this.value);

                this.setDate(date);
            }

            if (this.disableDatesTo) {
                this.disabledDates.to = this.getDateFromString(this.disableDatesTo);
            }

            if (this.disableDatesFrom) {
                this.disabledDates.from = this.getDateFromString(this.disableDatesFrom);
            }

            const eventName = 'set' + this.name.replace(/^\w/, c => c.toUpperCase());

            window.events.$on(eventName, value => {
                this.setDate(value);
            });

        },

        methods: {

            getDate(day, month, year) {
                return new Date(year, month, day);
            },

            getDateFromString(date, separator = '/') {
                const parts = date.split(separator);
                return this.getDate(parts[0], parts[1] - 1, parts[2]);
            },

            getToday() {
                return new Date();
            },

            setDate(date) {
                this.date = date;
            },

            update(event) {
                this.broadcast(event);
            },

            broadcast(date) {
                if (this.shouldEmitEvent) {
                    const name = 'update' + this.name.replace(/^\w/, c => c.toUpperCase());
                    const value = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
                    window.events.$emit(name, value);
                }
            }

        }

    }

</script>
